"use strict";

exports.__esModule = true;
exports["default"] = Hamburger;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Hamburger(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.938 4.802a2.4 2.4 0 0 1-2.4 2.4H2.462a2.4 2.4 0 0 1 .001-4.8h27.076a2.4 2.4 0 0 1 2.399 2.4zm0 11.198a2.4 2.4 0 0 1-2.4 2.4H2.462a2.4 2.4 0 0 1 .001-4.8h27.076a2.4 2.4 0 0 1 2.399 2.4zm0 11.198a2.4 2.4 0 0 1-2.4 2.4l-27.076-.001a2.4 2.4 0 0 1 .001-4.799h27.076a2.4 2.4 0 0 1 2.399 2.4z"
  }));
}